import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

import { RouteInfo } from './sidebar.metadata';
import { SidebarService } from '@shared/components/sidebar/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  showMenu = '';
  showSubMenu = '';
  sidebarnavItems: RouteInfo[] = [];
  path = '';


  @Output() toggleSidebar = new EventEmitter<boolean>();

  constructor(
    private menuService: SidebarService,
    private router: Router
  ) {
    this.menuService.items.subscribe(menuItems => {
      this.sidebarnavItems = menuItems;

      const urlPath = this.router.url.split('?')[0];
      this.path = '';
      for (const m of this.sidebarnavItems) {
        for (const s of m.submenu) {
          if (urlPath === s.path || urlPath.startsWith(`${s.path}/`)) {
            this.path = m.title;
            break;
          }
        }
        if (this.path) {
          break;
        }
      }

      if (this.path) {
        this.showMenu = this.path;
      } else {
        this.showMenu = '0';
      }
    });
  }

  addExpandClass(element: string, shouldToggleSidebar = true): void {
    if (shouldToggleSidebar) {
      this.toggleSidebar.emit();
    }

    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any): void {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
